<div
  class="blog-card-skeleton"
  [class.blog-card-skeleton--static]="!animated"
  aria-hidden="true"
>
  <div class="skeleton skeleton-image"></div>
  <div class="skeleton-body">
    <div class="skeleton skeleton-chip"></div>
    <div class="skeleton skeleton-title"></div>
    <div class="skeleton skeleton-title-short"></div>
    <div class="skeleton skeleton-excerpt"></div>
    <div class="skeleton skeleton-excerpt"></div>
    <div class="skeleton skeleton-excerpt-short"></div>
    <div class="skeleton-meta">
      <div class="skeleton skeleton-date"></div>
      <div class="skeleton skeleton-cta"></div>
    </div>
  </div>
</div>
